import React from "react";
import "./Sidebar.css";
import Steps from "../FormSteps/Steps";
import xenonstackLogo from "../../assets/xenonstack-logo.svg";
export default function BookDemoSidebar({ step }) {
  return (
      <div className="sidebar-wrapper">
        <div className="sidebar-content">
          <img src={xenonstackLogo} alt="xenonstack.ai-image" />
          <h1>Book Demo</h1>
          <p>Book a time to chat 1:1 with a XenonStack Team member</p>
        </div>
        <Steps step={step} />
      </div>
  );
}
